
export default [
  {
    description: 'Mapeamento Professor / Disciplina',
    path: '/academico/funcionario',
    name: 'mapper_prof_disciplina',
    component: () => import('@/views/academico/funcionario/mapper_prof_disciplina.vue'),
    meta: {
      isLegacy: false,
      permissions: [
      ],
    },
    goesToMenu: true,
  },
]

